Object.defineProperty(exports,"__esModule",{value:true});exports.zoomContainerMixin=undefined;var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _jsxFileName="src/components/containers/victory-zoom-container.js",_this3=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=require("prop-types");var _propTypes2=_interopRequireDefault(_propTypes);
var _react=require("react");var _react2=_interopRequireDefault(_react);

var _zoomHelpers=require("./zoom-helpers");var _zoomHelpers2=_interopRequireDefault(_zoomHelpers);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var zoomContainerMixin=exports.zoomContainerMixin=function zoomContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictoryZoomContainer,_base);function VictoryZoomContainer(){_classCallCheck(this,VictoryZoomContainer);return _possibleConstructorReturn(this,(VictoryZoomContainer.__proto__||Object.getPrototypeOf(VictoryZoomContainer)).apply(this,arguments));}_createClass(VictoryZoomContainer,[{key:"clipDataComponents",value:function clipDataComponents(





























































children,props){var
scale=props.scale,clipContainerComponent=props.clipContainerComponent,polar=props.polar,origin=props.origin;
var rangeX=scale.x.range();
var rangeY=scale.y.range();
var plottableWidth=Math.abs(rangeX[0]-rangeX[1]);
var plottableHeight=Math.abs(rangeY[0]-rangeY[1]);
var childComponents=[];
var group=[];
var groupNumber=0;
var radius=Math.max.apply(Math,_toConsumableArray(rangeY));
var makeGroup=function makeGroup(arr,index){
return Array.isArray(arr)&&arr.length?
_react2.default.cloneElement(clipContainerComponent,{
key:"ZoomClipContainer-"+index,
clipWidth:plottableWidth,
clipHeight:plottableHeight,
translateX:Math.min.apply(Math,_toConsumableArray(rangeX)),
translateY:Math.min.apply(Math,_toConsumableArray(rangeY)),
children:arr,
polar:polar,
origin:polar?origin:undefined,
radius:polar?radius:undefined}):

null;
};

var findNextAxis=function findNextAxis(start){
var subset=children.slice(start);
return subset.findIndex(function(child){return child.type.displayName==="VictoryAxis";})+start;
};

var axisIndex=findNextAxis(0);

if(axisIndex===-1){
return makeGroup(children,groupNumber);
}
for(var i=0,len=children.length;i<len;i++){
if(i===axisIndex){
childComponents.push(makeGroup(group,groupNumber),children[i]);
axisIndex=findNextAxis(i+1);
group=[];
groupNumber++;
}else{
group.push(children[i]);
}
}
childComponents.push(makeGroup(group,groupNumber));
return childComponents.filter(Boolean);
}},{key:"modifyPolarDomain",value:function modifyPolarDomain(

domain,originalDomain){

return{
x:originalDomain.x,
y:[0,domain.y[1]]};

}},{key:"modifyChildren",value:function modifyChildren(

props){var _this2=this;
var childComponents=_react2.default.Children.toArray(props.children);

return childComponents.map(function(child){var
currentDomain=props.currentDomain;
var originalDomain=(0,_defaults3.default)({},props.originalDomain,props.domain);
var zoomDomain=(0,_defaults3.default)({},props.zoomDomain,props.domain);
var cachedZoomDomain=(0,_defaults3.default)({},props.cachedZoomDomain,props.domain);
var domain=(0,_isEqual3.default)(zoomDomain,cachedZoomDomain)?
(0,_defaults3.default)({},currentDomain,originalDomain):zoomDomain;
var newProps=props.polar?
{domain:_this2.modifyPolarDomain(domain,originalDomain)}:{domain:domain};
return _react2.default.cloneElement(
child,(0,_defaults3.default)(newProps,child.props));

});
}},{key:"getChildren",value:function getChildren(


props){
var children=this.modifyChildren(props);
return this.clipDataComponents(children,props);
}}]);return VictoryZoomContainer;}(base),_class.displayName="VictoryZoomContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{allowZoom:_propTypes2.default.bool,clipContainerComponent:_propTypes2.default.element.isRequired,dimension:_propTypes2.default.oneOf(["x","y"]),minimumZoom:_propTypes2.default.shape({x:_propTypes2.default.number,y:_propTypes2.default.number}),onDomainChange:_propTypes2.default.func,zoomDomain:_propTypes2.default.shape({x:_victoryCore.PropTypes.domain,y:_victoryCore.PropTypes.domain})}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{clipContainerComponent:_react2.default.createElement(_victoryCore.VictoryClipContainer,{__source:{fileName:_jsxFileName,lineNumber:28}}),allowZoom:true}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){return _zoomHelpers2.default.onMouseDown(evt,targetProps);},onMouseUp:function onMouseUp(evt,targetProps){return _zoomHelpers2.default.onMouseUp(evt,targetProps);},onMouseLeave:function onMouseLeave(evt,targetProps){return _zoomHelpers2.default.onMouseLeave(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps,eventKey,ctx){evt.preventDefault();var mutations=_zoomHelpers2.default.onMouseMove(evt,targetProps,eventKey,ctx);if(mutations.id!==_this3.mouseMoveMutationId){_this3.mouseMoveMutationId=mutations.id;return mutations.mutations;}return undefined;},onWheel:function onWheel(evt,targetProps,eventKey,ctx){evt.preventDefault();var mutations=_zoomHelpers2.default.onWheel(evt,targetProps,eventKey,ctx);if(mutations.id!==_this3.wheelMutationId){_this3.wheelMutationId=mutations.id;return mutations.mutations;}return undefined;}}}],_temp;};exports.default=


zoomContainerMixin(_victoryCore.VictoryContainer);


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/victory-zoom-container.js
// module id = 630
// module chunks = 0